export interface ResolveActorResponse {
  actorId: string;
}

export interface TrackEventRequest {
  actorId: string;
  eventType: string;
  productId?: string;
  context: string;
  quantity?: number;
  metadata?: Record<string, unknown>;
}
